import {
  RECEIVE_PRINTERLESS_RETURN_INFO,
  TRIGGER_PRINTERLESS_ERROR_STATE,
  TOGGLE_PRINTERLESS_INFO_EMAIL_INPUT,
  UPDATE_PRINTERLESS_EMAIL_INPUT,
  TOGGLE_PRINTERLESS_EMAIL_SENT,
} from '../../actions/printerlessInfo';

export const initialState = {
  apiFailure: false,
  labelUrl: null,
  barcodeUrl: null,
  referenceNumber: null,
  totalItemQuantity: 0,
  items: [],
  carrier: '',
  showEmailInput: false,
  customerEmail: '',
  emailInput: '',
  emailSent: false,
  alternateEmailAddress: '',
  orderMethod: null,
  dropOffLocation: null,
  partnerReturnCode: '',
};

export default (
  state = initialState,
  {
    type,
    data: {
      labelUrl,
      barcodeUrl,
      totalItemQuantity,
      items,
      carrier,
      customerEmail,
      emailInput,
      alternateEmailAddress,
      orderMethod,
      dropOffLocation,
      partnerReturnCode,
    } = {},
  } = {},
) => {
  switch (type) {
    case RECEIVE_PRINTERLESS_RETURN_INFO:
      return {
        ...state,
        labelUrl,
        barcodeUrl,
        customerEmail,
        totalItemQuantity,
        items,
        carrier,
        orderMethod,
        dropOffLocation,
        partnerReturnCode,
      };

    case TOGGLE_PRINTERLESS_INFO_EMAIL_INPUT:
      return {
        ...state,
        showEmailInput: !state.showEmailInput,
      };

    case UPDATE_PRINTERLESS_EMAIL_INPUT:
      return {
        ...state,
        emailInput,
      };

    case TOGGLE_PRINTERLESS_EMAIL_SENT:
      return {
        ...state,
        emailSent: true,
        alternateEmailAddress,
      };

    case TRIGGER_PRINTERLESS_ERROR_STATE:
      return {
        ...state,
        apiFailure: true,
      };

    default:
      return state;
  }
};
